<template>
    <div class="panel">
        <div class="panel-heading clearfix">
            <small v-if="isNew" class="pull-right">not yet created</small>
            <transition name="slide-fade">
                <small v-if="updated" class="pull-right updated">updated</small>
            </transition>
            <span class="proposal-inv-title">Cover Page</span>
        </div>
        <div class="panel-body panel-block">
            <fieldset>
                <div class="form-body">
                    <div class="form-group">
                        <label class="control-label">Title:</label>
                        <input ref="input" class="form-control" type="text" v-model="model.title">
                    </div>
                    <div class="form-group">
                        <label class="control-label">Recipient:</label>
                        <input class="form-control" type="text" v-model="model.data.recipient" />
                    </div>

                    <div class="form-group">
                        <label class="control-label">Author:</label>
                        <input class="form-control" type="text" v-model="model.data.author" />
                    </div>
                </div><!-- .form-body -->
            </fieldset>

        </div>
    </div>
</template>

<script>
    import SortableBlock from "./SortableBlock";
    export default {
        name: "coverBlock",
        mixins: [ SortableBlock ],
        props:{
            invoiceId: { default: '' },
            input: {
                type: Object,
                default: function () {
                    return {
                        public_id: 0,
                        title: 'Web Design Proposal for #company',
                        page_break: true,
                        type: 'coverBlock',
                        content: '',
                        data: {
                            author: '#myfname #mylname',
                            recipient: '#contactfname #contactlname'
                        }
                    }
                }
            },
        },
        watch: {
            model: {
                handler: function (val, oldVal) {
                    // if (oldVal === false || this.disableWatch) {
                    //     this.disableWatch = false;
                    //     return;
                    // }
                    this.save();
                },
                deep: true
            },
        },
        data() {
            return {
                isNew: false,
                timeout: false,
                updated: false,
                model: false,
                disableWatch: false,
            }
        },
        created() {
            this.model = Object.assign({invoice_id: this.invoiceId}, this.input);
            if (this.model.public_id === 0) {
                this.isNew = true;
            }
        },
        methods: {
            save() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.store();
                }, 1500);
            },
            store() {
                this.$store('/api/proposal/post', this);
            },
            callback(data)
            {
                if (typeof data.public_id !== 'undefined' && data.public_id) {
                    this.disableWatch = true;
                    this.isNew = false;
                    this.model.public_id = data.public_id;
                }
                this.showUpdated();
            },
            showUpdated()
            {
                this.updated = true;
                setTimeout(() => {
                    this.updated = false;
                }, 800);
            }
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
        },

    }
</script>

<style scoped>
    .updated {
        margin-top: 7px;
        color: #46C37B;
    }
    .panel-body.panel-block {
        padding: 0 15px !important;
    }
    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }
</style>